var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.availableTags.length
    ? _c("div", { staticClass: "tags-filter" }, [
        _c("label", { staticClass: "provider-label" }, [
          _vm._v("Filter by provider:"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tags-list" },
          _vm._l(_setup.availableTags, function (tag) {
            return _c(
              "span",
              {
                key: tag,
                on: {
                  click: function ($event) {
                    return _setup.handleToggleTag(tag)
                  },
                },
              },
              [
                _c(_setup.CBadge, {
                  staticClass: "tag-filter",
                  class: { active: _setup.selectedTags.includes(tag) },
                  attrs: { text: tag, pill: "" },
                }),
              ],
              1
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }